import { z } from 'zod';

export const ModemModelSchema = z.object({
    email: z.string(),
    imei: z.string(),
    ip: z.string()
});

export type ModemModelData = z.infer<typeof ModemModelSchema>;

export const ModemModelListSchema = z.array(ModemModelSchema);

export type ModemModelDataList = z.infer<typeof ModemModelListSchema>;

export const MultipleModemsModelSchema = z.object({
    imeis: ModemModelListSchema
});

export type MultipleModemsModelData = z.infer<typeof MultipleModemsModelSchema>;

export const UserEmailListSchema = z.object({
    users: z.array(z.string())
});

export type UserEmailListData = z.infer<typeof UserEmailListSchema>;
